

const IndexDocusignWebhooksItemSchema = {
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default IndexDocusignWebhooksItemSchema
